module.exports = __webpack_public_path__ + "img/Enigma.d35f6441.png";